export const ButtonSlice = () => <></>;
